// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__2xeV0","image-wrapper":"styles-m__image-wrapper__3mAyO","text-wrapper":"styles-m__text-wrapper__30hMc","headline":"styles-m__headline__Mz20l"};